// @ts-nocheck
import * as React from 'react';
import classNames from 'classnames';
import { Form, Tooltip } from 'antd';
import './validation.scss';
import Icon from 'atoms/icons/icon';
import { getGridMetadata } from 'models/dynamicGrid/selector';
import { useSelector } from 'react-redux';

const isOrderQtyField = (identifier: string) =>
	identifier === 'OrderQty' || identifier === 'ItemOrderQty' || identifier?.includes('|ItemOrderQty');

const OrderValidation = (props: any) => {
	const { children, hasError, errorMessage, hasWarning, tableId, row, rowIdentifier, isTouched } = props;

	const gridMetaData = useSelector((state) => getGridMetadata(state, tableId));
	const hasGridEditOperationDisabled = gridMetaData?.isGridEditDisabledOverride;

	const shouldShowIndicator = (hasError || hasWarning) && isTouched;
	const isUpdated = row?.[rowIdentifier]?.isUpdated;
	const showBlueHighlight = isUpdated && isOrderQtyField(rowIdentifier);

	const classes: any = classNames([
		'validation-form-item',
		{ 'validation-form-item-theme': props.isTheme },
		{ 'validation-edit-disabled': hasGridEditOperationDisabled },
		{ 'validation-updated-cell': showBlueHighlight },
	]);
	const validationStatus = shouldShowIndicator ? 'error' : undefined;

	return (
		<Form.Item className={classes} validateStatus={validationStatus}>
			<div className="validation">
				<div className="validation--input">{children}</div>
				{shouldShowIndicator && (
					<Tooltip placement="topLeft" title={errorMessage} arrowPointAtCenter>
						<div>
							<Icon
								extraClass={hasWarning ? 'warning' : 'error'}
								faAlias="faInfoCircle"
								size="small"
							></Icon>
						</div>
					</Tooltip>
				)}
			</div>
		</Form.Item>
	);
};

export default OrderValidation;
